import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import styles from './box-layout.styles';
import SwipeableViews from 'react-swipeable-views';
import Pagination from './common/Pagination';
import MainUnitLayout from './Mainunit-layout';
import CoolLayout from './Cool-layout';
import Hd36Layout from './HD36-layout.js';
import L60Layout from './l60-layout.js';
import M22Layout from './Main22-layout';
import M24Layout from './Main24-layout';
import { FastlaneProLayout } from './fastlane-pro';
import PreAssignmentLayout from '../unplugged-assign-prescriptions/pre-assignment-layout';
import C30Layout from './C30.layout.js';

let deactivatedBin = [];
let selectedTabIndex = 0;
let currentTabIndex = 0;
let IsTabSelect = false;

const boxes_type_enum = {
    MAIN: 'd5e3af71-ab56-44c4-bf4d-de7b53e47f38',
    L60: '415f008a-2913-49ea-9c62-e830f2c07008',
    COOL: 'fdfe7cf1-d266-4e1a-b26d-87423ce2b56b',
    HD36: '68534189-6ac4-4fdb-ae16-374d7870fd92',
    M22: 'eb5e33fc-b744-46fb-9ee6-802c602977c1',
    M24: '9fa0079a-3d98-4942-88c8-3f6537d68e48',
    FASTLANE: 'e9da3c38-b838-4054-8b74-dcfb7d2713d8',
    C30: '3c5cd3cd-bf63-4662-81da-a1d68e2e0fcf',
};

export class boxLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedUnit: this.props.currentTabIndex
        }
    }
    handleChangeIndex = index => {
        this.setState({
            selectedUnit: index
        });
        selectedTabIndex = index;
        IsTabSelect = true;
        this.props.getSelectedUnitName(index);
    };

    componentDidMount() {
        IsTabSelect = false;
        this.setState({
            selectedUnit: this.props.currentTabIndex
        });
        currentTabIndex = this.props.currentTabIndex;
    }
    componentWillReceiveProps() {
        currentTabIndex = IsTabSelect === false ? this.props.currentTabIndex : selectedTabIndex;
        this.setState({
            selectedUnit: currentTabIndex
        });
        setTimeout(() => {
            currentTabIndex = IsTabSelect === false ? this.props.currentTabIndex : selectedTabIndex;
            this.setState({
                selectedUnit: currentTabIndex
            });
        }, 1000)
        const { deactivatedBins } = this.props;
        if (deactivatedBins && deactivatedBins.length > 0) {
            deactivatedBins.map((item) => {
                return true
            })
        }
        else {
            deactivatedBin.map((item) => {
                return true
            })
            deactivatedBin = [];
        }
    }
    Selectedbin = (binId, position, flag) => {
        this.props.getSelectedBin(binId, position, flag);
    }

    getExpansionUnitsByPos = (position) => {
        const { expansionUnits } = this.props;
        return expansionUnits.filter(x => x.pos === position);
    }

    getExpansionsCounts = () => {
        let boxLeftExpansionObjectArray = [];
        let boxRightExpansionObjectArray = [];
        let RightAndLeftExpansions = {}
        const { expansionUnits } = this.props;
        for (let unit = 0; unit < expansionUnits.length; unit++) {
            if (expansionUnits[unit].box_position < 0) {
                let expansionObj = {
                    expansionId: expansionUnits[unit].id,
                    box_position: Number(expansionUnits[unit].box_position),
                    bin_column_count: expansionUnits[unit].bin_column_count
                }
                if (expansionObj && expansionObj.expansionId && expansionObj.box_position !== 0) {
                    boxLeftExpansionObjectArray.push(expansionObj);
                }
            } else {
                let expansionObj = {
                    expansionId: expansionUnits[unit].id,
                    box_position: Number(expansionUnits[unit].box_position),
                    bin_column_count: expansionUnits[unit].bin_column_count
                }
                if (expansionObj && expansionObj.expansionId && expansionObj.box_position !== 0) {
                    boxRightExpansionObjectArray.push(expansionObj);
                }
            }
        }
        RightAndLeftExpansions.leftExpansions = boxLeftExpansionObjectArray.reverse();
        RightAndLeftExpansions.rightExpansions = boxRightExpansionObjectArray;
        return RightAndLeftExpansions;
    }

    render() {
        const { selectedUnit } = this.state;
        const { boxTypeId, t, allowMultiBinsPickup, is_pre_assignment, isViewPermissionAllowed } = this.props;
        let { expansionUnits } = this.props;
        const Expansions = this.getExpansionsCounts();
        if (is_pre_assignment) {
            expansionUnits = expansionUnits.filter((item) => item.pos === 'M' || item.pos === 'M22')
        }
        return (
            <div key="boxInnerLayout">
                <SwipeableViews index={is_pre_assignment ? 0 : selectedUnit} onChangeIndex={this.handleChangeIndex}>

                    {(expansionUnits && expansionUnits !== undefined &&
                        expansionUnits.length > 0) &&
                        expansionUnits.map((item, index) => {
                            let getExpansionUnits = this.getExpansionUnitsByPos(item.pos);
                            if (item.pos === 'L') {
                                if (item && item.expansion_id === boxes_type_enum.L60) {
                                    return !is_pre_assignment && (
                                        <L60Layout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                }
                                else if (item && item.expansion_id === boxes_type_enum.HD36) {
                                    return !is_pre_assignment && (
                                        <Hd36Layout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                }
                                else if (item && item.expansion_id === boxes_type_enum.COOL) {
                                    return !is_pre_assignment && (
                                        <CoolLayout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                } else if (item && item.expansion_id === boxes_type_enum.C30) {
                                    return !is_pre_assignment && (
                                        <C30Layout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                }
                            }
                            if (item.pos === 'M') {
                                return is_pre_assignment && this.props.BoxID ? (
                                    <PreAssignmentLayout
                                        makeAPICall={this.props.makeAPICall}
                                        BoxID={this.props.BoxID}
                                        getPrescriptionDetails={this.props.getPrescriptionDetails}
                                        getAvailableBinsCount={this.props.getAvailableBinsCount}
                                        t={t}
                                        isViewPermissionAllowed={isViewPermissionAllowed}
                                    />
                                ) : (
                                    <MainUnitLayout
                                        key={index}
                                        expansion={item}
                                        prefix={item.pos}
                                        box_position={item.box_position}
                                        Selectedbin={this.Selectedbin}
                                        BinStatus={this.props.BinStatus}
                                        getPrescriptionDetails={this.props.getPrescriptionDetails}
                                        isADACompatible={this.props.isADACompatible}
                                        deactivatedBins={this.props.deactivatedBins}
                                        PatientID={this.props.PatientID}
                                        ADAData={this.props.ADAData}
                                        isViewPermissionAllowed={isViewPermissionAllowed}
                                    />
                                )
                            } else if (item.pos === 'M22') {
                                return is_pre_assignment && this.props.BoxID ? (
                                    <PreAssignmentLayout
                                        makeAPICall={this.props.makeAPICall}
                                        BoxID={this.props.BoxID}
                                        getPrescriptionDetails={this.props.getPrescriptionDetails}
                                        getAvailableBinsCount={this.props.getAvailableBinsCount}
                                        t={t}
                                        isViewPermissionAllowed={isViewPermissionAllowed}
                                    />
                                ) : (
                                    <M22Layout
                                        key={index}
                                        expansion={item}
                                        prefix={item.pos + item.selectedUnitIndex}
                                        box_position={item.box_position}
                                        Selectedbin={this.Selectedbin}
                                        BinStatus={this.props.BinStatus}
                                        deactivatedBins={this.props.deactivatedBins}
                                        getPrescriptionDetails={this.props.getPrescriptionDetails}
                                        isADACompatible={this.props.isADACompatible}
                                        PatientID={this.props.PatientID}
                                        ADAData={this.props.ADAData}
                                        isViewPermissionAllowed={isViewPermissionAllowed}
                                    />
                                )
                            } else if (item.pos === 'M24') {
                                return is_pre_assignment && this.props.BoxID ? (
                                    <PreAssignmentLayout
                                        makeAPICall={this.props.makeAPICall}
                                        BoxID={this.props.BoxID}
                                        getPrescriptionDetails={this.props.getPrescriptionDetails}
                                        getAvailableBinsCount={this.props.getAvailableBinsCount}
                                        t={t}
                                        isViewPermissionAllowed={isViewPermissionAllowed}
                                    />
                                ) : (
                                    <M24Layout
                                        key={index}
                                        expansion={item}
                                        prefix={item.pos + item.selectedUnitIndex}
                                        box_position={item.box_position}
                                        Selectedbin={this.Selectedbin}
                                        BinStatus={this.props.BinStatus}
                                        deactivatedBins={this.props.deactivatedBins}
                                        getPrescriptionDetails={this.props.getPrescriptionDetails}
                                        isADACompatible={this.props.isADACompatible}
                                        PatientID={this.props.PatientID}
                                        ADAData={this.props.ADAData}
                                        isViewPermissionAllowed={isViewPermissionAllowed}
                                    />
                                )
                            } else if (item.pos === 'FASTLANE') {
                                return (
                                    <FastlaneProLayout
                                        key={index}
                                        t={t}
                                        allowMultiBinsPickup={allowMultiBinsPickup}
                                        expansion={item}
                                        prefix={item.pos}
                                        box_position={item.box_position}
                                        Selectedbin={this.Selectedbin}
                                        BinStatus={this.props.BinStatus}
                                        getPrescriptionDetails={this.props.getPrescriptionDetails}
                                        deactivatedBins={this.props.deactivatedBins}
                                        PatientID={this.props.PatientID}
                                        makeAPICall={this.props.makeFastlaneAPICall}
                                        BoxID={this.props.BoxID}
                                        selectedBox={this.props.selectedBox}
                                        isViewPermissionAllowed={isViewPermissionAllowed}
                                    />
                                )
                            }
                            if (item.pos === 'R') {
                                if (item && item.expansion_id === boxes_type_enum.L60) {
                                    return !is_pre_assignment && (
                                        <L60Layout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                }
                                else if (item && item.expansion_id === boxes_type_enum.HD36) {
                                    return !is_pre_assignment && (
                                        <Hd36Layout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                }
                                else if (item && item.expansion_id === boxes_type_enum.COOL) {
                                    return !is_pre_assignment && (
                                        <CoolLayout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                } else if (item && item.expansion_id === boxes_type_enum.C30) {
                                    return !is_pre_assignment && (
                                        <C30Layout
                                            key={index}
                                            expansion={item}
                                            prefix={item.pos + item.selectedUnitIndex}
                                            box_position={item.box_position}
                                            Selectedbin={this.Selectedbin}
                                            BinStatus={this.props.BinStatus}
                                            deactivatedBins={this.props.deactivatedBins}
                                            getPrescriptionDetails={this.props.getPrescriptionDetails}
                                            previousExpansion={getExpansionUnits[(index + getExpansionUnits.length - 1) % getExpansionUnits.length]}
                                            ExpansionsCounts={Expansions}
                                            boxTypeId={boxTypeId}
                                            isViewPermissionAllowed={isViewPermissionAllowed}
                                        />
                                    )
                                }
                            }

                            return true
                        })
                    }
                </SwipeableViews>
                <Pagination dots={
                    expansionUnits && expansionUnits !== undefined && expansionUnits.length > 0 ?
                        expansionUnits.length === 1 ? 0 : expansionUnits && expansionUnits.length
                        :
                        0
                }
                    index={is_pre_assignment ? 0 : selectedUnit} onChangeIndex={this.handleChangeIndex} />

            </div>
        );
    }
}

export default withStyles(styles)(boxLayout);



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/box-layout.js